var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',{staticClass:"emissions-reduction-performance"},[_c('h1',{staticClass:"section-title activity-title"},[_vm._v("Emissions Reduction Performance")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.comparisonAgainstBaseYear)}})]):_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }